@if (!isBulk) {
    <label for="promoterType"
        >Promoter Type<span
            class="icon-info cdp-info-ico cdp-info-ico-right"
            [hcTooltip]="tooltips.promoterTypeToolTip"
        ></span
    ></label>
}

<ng-select
    [(ngModel)]="promoterType"
    [items]="promoterTypeOptions"
    bindValue="name"
    bindLabel="name"
    [clearable]="false"
    [searchable]="false"
    appendTo="body"
    [disabled]="disabled"
    (change)="onChangePromoterType($event)"
    style="min-width: 225px"
>
    <ng-template ng-label-tmp let-item="item">
        <span class="icon-cogs promoter-icon"></span>
        <span>{{ item.name }}</span>
    </ng-template>
    <ng-template ng-option-tmp let-item="item">
        <div [class.ref-mode-option]="isBulk" tight="true">
            <span>{{ item.name }}</span>
            @if (isBulk) {
                <div>
                    <span class="icon-info cdp-info-ico" hcTooltip="{{ item.name }}: {{ item.description }}"></span>
                </div>
            } @else {
                <span class="ref-mode-description">{{ item.description }}</span>
            }
        </div>
    </ng-template>
</ng-select>
